import { z } from 'zod'
import { PASSWORD_MIN_LENGTH } from '~/utils/user.schema'

const emailField = z.string()
  .trim()
  .min(1, 'Ingresa tu email')
  .pipe(z.email('El email debe tener un formato válido'))

const passwordField = z.string().min(
  PASSWORD_MIN_LENGTH,
  `La contraseña debe tener al menos ${PASSWORD_MIN_LENGTH} caracteres`
)

export const loginSchema = z.object({
  email: emailField,
  password: passwordField
})

export const registerSchema = z.object({
  name: z.string().trim().min(2, 'El nombre debe tener al menos 2 caracteres'),
  email: emailField,
  password: passwordField
})
